<template>
    <HeaderContent title="Checkout Report" />

    <ActionContent
        :cta="false"
        :filter-modal="false"
      @action="showModal"
      @showFilter="modalFilter = !modalFilter"
      v-model:start-date="startDate"
      v-model:end-date="endDate"
      v-model:search="search"
      @search-query="handleSearch"
        :show-export="true"
        @export="handleExport"
    />
    
    <ReservationStatistic title="Reservation Statistics" :data="statistics" />
  
    <ReservationFilter
      :modalFilter="modalFilter"
      @update:modalFilter="modalFilter = $event"
      @filter="handleFilter"
    />
  
    <ReservationDataTable
      :data="reservations"
      :header="headers"
      :currentPage="currentPage"
      
    />
  
    <ToastResponse
      v-model="modalResponse.toast"
      :text="modalResponse.text"
      :success="modalResponse.success"
    >
    </ToastResponse>
  </template>
  
  <script>
  import { ref, inject, onMounted, watch } from "vue";
  import HeaderContent from "@/components/HeaderContent.vue";
  import ActionContent from "@/components/ActionContent.vue";
  import ReservationStatistic from "@/components/StatisticData.vue";
//   import ReservationFilter from "./ReservationFilter.vue";
//   import ReservationForm from "./ReservationForm.vue";
  import ReservationDataTable from "@/components/DataTable.vue";
//   import ReservationConfirm from "@/components/ModalDialog.vue";
//   import iconVoid from "../../../../public/icons/rectangle-xmark.svg";
//   import iconReserved from "../../../../public/icons/receipt.svg";
  import iconCompleted from "../../../../public/icons/clipboard-check.svg";
//   import iconCheckOut from "../../../../public/icons/door-open.svg";
  import iconOverall from "../../../../public/icons/square-poll-vertical.svg";
  import ToastResponse from "@/components/ToastResponse.vue";
  import { getFormattedDate } from "@/composable/getDateTimeFormatter";
  import { formatIDR } from "@/utils/currency";
  
  //import axios from 'axios';
  //import { reactive } from "vue";
  // import { useRouter } from "vue-router";
  
  export default {
    components: {
      HeaderContent,
      ActionContent,
      
      ReservationStatistic,
      ReservationDataTable,
      ToastResponse,
    },
  
    setup() {
      // const router = useRouter();

      const repositories = inject("repositories");
      const reservationRepository = repositories
        ? repositories.reservations
        : null;
  
      const staffRepository = repositories?.employee;
  
      const modal = ref(false);
      const modalDetail = ref(false);
      const modalExtraCharge = ref(false);
      const modalReschedule = ref(false);
      const selected = ref(null);
      const reservationUuid = ref(null);
      const modalFilter = ref(false);
      const modalConfirm = ref(false);
    //   const modalType = ref(""); // untuk menyimpan apakah modal delete atau void
      const currentPage = ref(1);
      const types = ref([]);
      const sources = ref([]);
      const payments = ref(["DP", "Lunas"]);
      const data = ref([]);
  
      const modalResponse = ref({
        toast: false,
        text: "",
        success: false,
      });
  
      const headers = ref([
        {
          key: "no",
          label: "No",
          sortable: true,
          tdClass: "text-right",
        },
        {
          key: "guest.fullname",
          label: "Guest Name",
          sortable: true,
        },
        {
          key: "number",
          label: "Reservation No",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "room_category",
          label: "Type",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "room.code",
          label: "Room Number",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "days",
          label: "Duration",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "start",
          label: "CheckIn",
          sortable: true,
          formatter: (value) => getFormattedDate(value),
          tdClass: "text-center",
        },
        {
          key: "end",
          label: "CheckOut",
          sortable: true,
          formatter: (value) => getFormattedDate(value),
          tdClass: "text-center",
        },
        {
          key: "source.name",
          label: "Source",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "payment_status",
          label: "Payment Status",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "grand_total",
          label: "Total Bill",
          sortable: false,
          tdClass: "text-right",
          formatter: (value) => formatIDR(value),
        },
        // {
        //   key: "action",
        //   label: "Actions",
        // },
        {
          key: "status_reservation",
          label: "Status",
          sortable: false,
          tdClass: "text-center",
        },
      ]);
  
      const customActions = ref([
        {
          label: "Detail",
          variant: "secondary",
          icon: "fas fa-print",
          action: async (item) => {
            // console.log(item);
  
            reservation.value = item;
            //reservationUuid.value = item.uuid;
            modalDetail.value = true;
          },
        },
        
      ]);
  
      const reservations = ref([]);
      const statistics = ref([]);
      const date = new Date();
      const getStartDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-01`;
      const getCurrentDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  
      //const startDate = ref(getCurrentDate);
      const startDate = ref(getStartDate);
      const endDate = ref(getCurrentDate);
  
      const search = ref("");
      const filterStatus = ref({
        status: null,
      });
      const reservation = ref({});

      const getAll = async (
        start = null,
        end = null,
        status = null,
        searchQuery = ""
      ) => {
        // *codingan baru naldi*
        // fallback supaya kalau null ambil dari filter/search saat ini
        if (!start) start = startDate.value;
        if (!end) end = endDate.value;
        if (!status) status = filterStatus.value?.status ?? "Check out";
        if (!searchQuery) searchQuery = search.value;
  
        const params = {};
        // const dateNow = new Date();
        // const todayString = dateNow.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  
        if (start) params.start = start;
        if (end) params.end = end;
        if (status && status !== "All") params.status = status;
        if (searchQuery) params.search = searchQuery;
  
        try {
          const res = await reservationRepository.getAll(params);
          const allReservations = res.data.data;
          reservations.value = allReservations;
  
          // Hitung statistik status
          const reservedCount = allReservations.filter(
            (item) => item.status === "Check Out"
          ).length;
  
        //   const voidCount = allReservations.filter(
        //     (item) => item.status === "Void"
        //   ).length;
        // Hitung total uang dari reservation checkout

          const totalRevenueCheckout = allReservations
          .filter((item) => item.status === "Check Out")
          .reduce((sum, item) => sum + Number(item.grand_total ?? 0), 0);

          const totalDuration = allReservations
          .filter((item) => item.status === "Check Out")
          .reduce((sum, item) => sum + Number(item.days ?? 0), 0);
  
          statistics.value = [
            {
              label: "Total",
              key: "Check Out: ",
              //value: res.data.statistics.reserved,
              value: reservedCount,
              color: "success",
              icon: iconCompleted,
            },
            {
              label: "Total",
              key: "Room: ",
              value: res.data?.statistics?.total_room ?? totalDuration,
              color: "warning",
              icon: iconOverall,
            },
            {
              label: "Total",
              key: "Revenue:",
              //value: res.data.statistics.overall,
              value: formatIDR(totalRevenueCheckout),
              color: "primary",
              icon: iconOverall,
            },
            // {
            //   label: "Total",
            //   key: "Void",
            //   value: res.data.statistics.void,
            //   value: voidCount,
            //   color: "danger",
            //   icon: iconVoid,
            // },
          ];
        } catch (err) {
          console.error(err);
        }
      };
  
      // *codingan baru: naldi*
      const refreshWithFilters = () => {
        getAll(
          startDate.value,
          endDate.value,
          filterStatus.value?.status,
          search.value
        );
      };
  
      const fetchReservations = async () => {
        await getAll(startDate.value, endDate.value);
      };
  
      const getById = async (uuid) => {
        await reservationRepository
          .getById(uuid)
          .then((res) => {
            modal.value = true;
            reservation.value = res.data.data;
          })
          .catch((err) => {
            console.error(err);
          });
      };
  
      const showModal = () => {
        modal.value = true;
        reservation.value = {};
      };
  
      const updateModal = (newValue) => {
        modal.value = newValue;
        reservation.value = null;
      };
  
      const updateReschedule = (newValue) => {
        modalReschedule.value = newValue;
        reservation.value = null;
      };
  
      const updateReservation = (updatedReservation) => {
        reservation.value = updatedReservation;
      };
  
      const handleFilter = (filterData) => {
        filterStatus.value = filterData;
        getAll(startDate.value, endDate.value);
      };
  
      function handleSearch(query) {
        search.value = query;
        getAll(startDate.value, endDate.value, filterStatus.value.status, query);
      }
  
    //   function handleConfirm() {
    //     if (modalType.value === "delete") {
    //       deleteData(reservationUuid.value);
    //     } else if (modalType.value === "void") {
    //       voidData(reservationUuid.value);
    //     }
    //   }

      const handleExport = () => {
          // router.push({
          //     name: "reservation-report-print",
          //     query: {
          //     start_date: startDate.value,
          //     end_date: endDate.value,
          //     status: "Check Out",
          //     },
          // });

          const query = new URLSearchParams({
            start_date: startDate.value,
            end_date: endDate.value,
            status: "Check Out",
          }).toString();

          window.open(`/reservation-report/print?${query}`, "_blank");
      };
  
    watch([startDate, endDate, filterStatus], () => {
      getAll(
        startDate.value,
        endDate.value,
        filterStatus.value.status,
        search.value
      );
    });
  
      // // *codingan lama: madhan*
      // onMounted(() => {
      //   getAll();
      // });
  
      //Get Admin Login
      const adminLogin = ref({});
      const getAdminByUuid = async () => {
        try {
          const localUser = localStorage.getItem("user");
          if (localUser) {
            const user = JSON.parse(localUser);
            const uuid = user.employee_uuid;
            const res = await staffRepository.getById(uuid);
            adminLogin.value = res.data.data;
          }
        } catch (e) {
          console.log(e);
        }
      };
  
      // *codingan baru: naldi*
      // ganti (cukup sekali & konsisten)
      onMounted(() => {
        fetchReservations();
        refreshWithFilters();
        //jika superadmin dari localStorage login tidak perlu panggil
        const user = JSON.parse(localStorage.getItem("user"));
        if (user.role !== "superadmin") {
          getAdminByUuid();
        }
      });
  
      return {
        getAll,
        getById,
        filterStatus,
        handleFilter,
        handleSearch,
        // handleConfirm,
        search,
        showModal,
        updateModal,
        updateReservation,
        updateReschedule,
        // deleteData,
        getCurrentDate,
        startDate,
        endDate,
        sources,
        selected,
        reservationUuid,
        modal,
        modalExtraCharge,
        modalReschedule,
        modalResponse,
        data,
        headers,
        types,
        payments,
        statistics,
        reservation,
        reservations,
        modalFilter,
        modalConfirm,
        currentPage,
        customActions,
        refreshWithFilters,
        modalDetail,
        adminLogin,
        handleExport,
      };
    },
  };
  </script>
  